module.exports = __webpack_public_path__ + "/bundle/asset/admission1-1-e0b74ac9b2fc2f17972a214e4c09714a.png";